import { api } from "@/lib/orgApi";

export async function listAllergenMaster({ q, allergenType, active = null } = {}) {
  const params = {};
  if (q) params.q = q;
  if (allergenType) params.allergenType = allergenType;
  if (active != null) params.active = active;
  const { data } = await api.get("/allergen-master", { params });
  return data;
}

export async function getAllergenMaster(id) {
  const { data } = await api.get(`/allergen-master/${encodeURIComponent(id)}`);
  return data;
}

export async function createAllergenMaster(payload) {
  const { data } = await api.post("/allergen-master", payload);
  return data;
}

export async function updateAllergenMaster(id, payload) {
  const { data } = await api.put(`/allergen-master/${encodeURIComponent(id)}`, payload);
  return data;
}

export async function setAllergenMasterActive(id, active) {
  const path = active ? "activate" : "deactivate";
  const { data } = await api.post(`/allergen-master/${encodeURIComponent(id)}/${path}`);
  return data;
}
